import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DetailService  } from '../services/detail.service';
import { Detail, DetailProperty } from '../objects/DetailObject';
import { ToasterService, Toast, BodyOutputType } from 'angular2-toaster';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from '../services/confirmation.service';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { MessagePopupService } from '../services/message-popup.service';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';
import { EnvService } from '../env.service';
import { TokenManager } from '../Globals';
import { HttpClient } from '@angular/common/http';
import { SafeHtml } from '@angular/platform-browser';
import { ResendVerificationComponent } from '../resend-verification/resend-verification.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-supplier-registration',
  templateUrl: './supplier-registration.component.html',
  styleUrls: ['./supplier-registration.component.css']
})
export class SupplierRegistrationComponent implements OnInit {

  // private readonly siteKey = "6Ld9260UAAAAAI6QMMrnC8NM7fNLSdemJoAVMlfZ";
  siteKey: string;
  private detailObject:Detail;
  isBusy : boolean = false;
  isSubmit : boolean = false;
  private componentId: string;
  private toasterService: ToasterService;
  private submitted: boolean = false;
  loaderConfig:any;
  portalName:string;
  supplierBackdrop: string;
  private enableCaptcha: boolean;
  supplierReg: SafeHtml;
  supplierHeaderText: SafeHtml;
  registerNote: SafeHtml;
  modalRef: BsModalRef;

  @ViewChild('supplierForm') public supplierForm: NgForm;

  constructor(private detailService:DetailService,
    toasterService: ToasterService, 
    private router:Router,
    private modalService: BsModalService,
    private confirmationService: ConfirmationService,
    private toasterMessageService: ToasterMessageService,
    private messagePopupService: MessagePopupService,
    private themeSettingService: ThemeSettingService,
    private globals: Globals,
    private workspaceService: WorkspaceService,
    private env:EnvService,
    private tokenManager: TokenManager, 
    private http:HttpClient) { 
    this.toasterService = toasterService;
    this.supplierHeaderText = this.env.supplierHeaderText;
    this.registerNote = this.env.registerNote;
    this.enableCaptcha = this.env.enableCaptcha;
    this.siteKey = this.env.captchaKey;
    this.supplierBackdrop = this.env.supplierBackdrop;
  }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
    document.querySelectorAll("body").item(0).style.position = "initial";
    this.requestSupplierRegistration();

    this.http.get("assets/external-html/supplier-registration.html", { responseType: "text" }).subscribe(result => {
      this.supplierReg = result;
      this.isBusy = false;
    }, error => {
      this.isBusy = false;
    })
  }

  resolved(captchaResponse: string) {
    //console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  requestSupplierRegistration() {
    this.isBusy = true;
    var actionKey = "";
    if (this.tokenManager.retrieve("BRNActionKey"))
    {
      actionKey = this.tokenManager.retrieve("BRNActionKey").replace(/["']/g, "");
    }
    
    this.detailService.requestSupplierRegistration(actionKey).subscribe(id => {
      if (id){
        // this.tokenManager.delete("BRNActionKey");
        this.componentId = id;
        this.detailService.getAnonymousDetail(id).subscribe(cardResult=> { 
          this.detailObject = JSON.parse(cardResult);
          this.detailObject.Properties = this.detailObject.Properties.filter(x => x.PropertyOrder != 0).filter(x => !x.PropertyIsHidden);
          
          this.detailObject.Properties.forEach(property => {
            if (property.ParentPropertyName){
              if (this.detailObject.Properties.find(x => x.PropertyName == property.ParentPropertyName)){
                this.detailObject.Properties.find(x => x.PropertyName == property.ParentPropertyName).ChildPropertyName = property.PropertyName;
              }
            }
          });
          
          this.detailObject.Captcha = "";
          this.isBusy = false;
        });
      }
    });
  }

  submitForm(actionCommand: string, form: NgForm){
    if (form.valid){
      this.detailAction(actionCommand);
    }
    else{
      this.submitted = true;
    }
  }

  onValueChange(prop: DetailProperty, value:string){
    if (prop.ParentPropertyName){
      if (this.supplierForm.control.get(prop.ParentPropertyName)){
        if (value != this.supplierForm.control.get(prop.ParentPropertyName).value){
          setTimeout(() => {
            this.supplierForm.control.get(prop.PropertyName).setErrors({noMatch:true});
          })
        }
        else{
          setTimeout(() => {
            this.supplierForm.control.get(prop.ParentPropertyName).setErrors(null);
          })
        }
      }
    }
    else if (prop.ChildPropertyName){
      if (this.supplierForm.control.get(prop.ChildPropertyName)){
        if (value != this.supplierForm.control.get(prop.ChildPropertyName).value){
          setTimeout(() => {
            this.supplierForm.control.get(prop.PropertyName).setErrors({noMatch:true});
          })
        }
        else{
          setTimeout(() => {
            this.supplierForm.control.get(prop.ChildPropertyName).setErrors(null);
          })
        }
      }
    }
    
    if (value){
      if (prop.PropertyDisplayFormat == 'UPPER'){
        value = value.toUpperCase();
      }
    }

    this.detailService.anonymousUpdateField(this.componentId, prop.PropertyName, value).subscribe(result=> { 
      // console.log(result);
    });
  }

  detailAction(actionCommand:string){
    this.isSubmit = true;

    this.detailService.anonymousDetailAction(this.componentId, actionCommand).subscribe(result=> {
      this.handleWorkflowReturn(result);
      this.isSubmit = false;
    },
    error => {
      this.popToast('Error', 'Something unexpected happened', 'error');
      this.isSubmit = false;
    });
  }

  handleWorkflowReturn(result: any): any {
    var command = JSON.parse(result);
      switch(command.ReturnType){
        case 0:
          if(command.Arguments){
            var path = [];
            command.Arguments.forEach(element => {
              path.push(element);
            });
            this.router.navigate(path);
          }
          break;
        case 1:
          this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe((respond) => {
            if (respond.answer == "OK"){
              if (command.SubType == "info"){
                this.router.navigate(["/"]);
              }
            }
          });
          break;
      }
      switch(command.RefreshType){
        case "self": this.requestSupplierRegistration(); break;
      }
  }

  popToast(title: string, body: string, type:string) {
    var toast: Toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onShowCallback: (toast) => 
      {
        var toaster = new Toaster();
        toaster.id = toast.toastId;
        toaster.timestamp = Date.now();
        toaster.title = toast.title;
        toaster.content = toast.body;
        this.toasterMessageService.pushToaster(toaster);
      }  
    };
    this.toasterService.pop(toast);
  }

  resendVerificationEmail(){
    var config = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-resend-verification',
      focus:false
    };
    this.modalRef = this.modalService.show(ResendVerificationComponent, config);
    this.modalService.onHide.subscribe((reason: string) => {
      if (document.querySelectorAll('.modal-backdrop').item(0)) {
        document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
      }
    })
    document.querySelectorAll('.modal-backdrop').item(0).classList.add('layer');
  }
}
